<script lang="ts" setup>
interface Props {
  minimal?: boolean
}
defineProps<Props>()

const { LocalConfigurationStore } = stores()
const contacts = computed(() => LocalConfigurationStore.value?.contacts)
const aboutPages = computed(() => LocalConfigurationStore.value?.aboutPages)

const paymentsBadges = [
  '/img/payments-badges/american-express.jpg',
  '/img/payments-badges/mastercard.jpg',
  '/img/payments-badges/visa.jpg',
]

const brands = ['visa', 'mastercard', 'american-express'] as const
</script>

<template>
  <div class="flex flex-col gap-4 py-4">
    <GridComponent
      v-if="!minimal"
      :cols="3"
      :min-cols="1"
      gap="xl"
    >
      <MenuComponent
        v-if="aboutPages"
        :items="
          aboutPages.map((i) => ({
            icon: i.icon,
            label: i.title,
            to: `/about/${i.code}`,
            external: false,
          }))
        "
        class="order-2 grid md:order-1"
      />

      <div class="order-1 flex flex-col gap-6 text-center md:order-2">
        <div class="flex flex-col gap-2">
          <span>SÍGUENOS EN LAS REDES</span>
          <div class="flex justify-center gap-2">
            <template
              v-for="sm in contacts?.filter((l) => l.type === 'social-media')"
              :key="sm.contact"
            >
              <a
                :href="sm.href"
                target="_blank"
              >
                <span
                  :class="getIconClass(sm.iconClass)"
                  class="text-4xl"
                />
              </a>
            </template>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <div class="leading-tight"> Nuestros procesadores de pago aceptan: </div>
          <div class="flex justify-center gap-2">
            <template
              v-for="brand in brands"
              :key="brand"
            >
              <SvgCcBrand
                :size="32"
                :brand="brand"
              />
            </template>
          </div>
          <div>
            <div class="flex justify-center gap-2">
              <div
                v-for="badge in paymentsBadges"
                :key="badge"
              >
                <ImageComponent
                  :src="badge"
                  class="w-full max-w-[80px] rounded"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <MenuComponent
        v-if="contacts"
        :items="
          contacts
            ?.filter((l) => l.type !== 'social-media')
            .map((i) => ({
              icon: i.iconClass,
              label: i.contact,
              to: i.href,
              external: false,
            }))
        "
        class="order-3 hidden md:inline"
      />
    </GridComponent>
    <div class="flex flex-col justify-center gap-4 text-center">
      <div class="flex justify-center">
        <ImageComponent
          :src="LocalConfigurationStore?.siteInfo?.uafCertificationBadgeUrl"
          class="h-28"
        />
      </div>
      <div>
        <div class="font-bold">
          {{ LocalConfigurationStore?.siteInfo?.copyright }} - &copy;
          {{ new Date().getFullYear() }}
        </div>
        <div class="text-xs md:text-sm">
          {{ LocalConfigurationStore?.siteInfo?.disclaimer }}
        </div>
      </div>
    </div>
  </div>
</template>
